import React, { useEffect, useState } from 'react';
import { Heading, HStack, Stat, StatLabel, StatNumber, Spinner, Box } from '@chakra-ui/react';
import AdminLayout from './AdminLayout';
import { supabase } from '../../services/supabaseClient';

function getTodayRange() {
  const now = new Date();
  const start = new Date(now.getFullYear(), now.getMonth(), now.getDate(), 0, 0, 0);
  const end = new Date(now.getFullYear(), now.getMonth(), now.getDate(), 23, 59, 59, 999);
  return {
    start: start.toISOString(),
    end: end.toISOString()
  };
}

const DashboardPage = () => {
  const [loading, setLoading] = useState(true);
  const [atendimentosHoje, setAtendimentosHoje] = useState(0);
  const [mensalistasCount, setMensalistasCount] = useState(0);

  useEffect(() => {
    const fetchAtendimentosHoje = async () => {
      setLoading(true);
      const { start, end } = getTodayRange();
      const { count, error } = await supabase
        .from('atendimentos')
        .select('id', { count: 'exact', head: true })
        .gte('iniciado_em', start)
        .lte('iniciado_em', end);
      if (!error) setAtendimentosHoje(count);
      setLoading(false);
    };
    fetchAtendimentosHoje();

    // Buscar contagem de mensalistas
    const fetchMensalistasCount = async () => {
      const { count, error } = await supabase
        .from('mensalistas')
        .select('id', { count: 'exact', head: true });
      if (!error) setMensalistasCount(count);
    };
    fetchMensalistasCount();

    // Atualizar em tempo real usando subscription (opcional, mas recomendado)
    const mensalistasChannel = supabase.channel('mensalistas-db-changes')
      .on('postgres_changes', { event: '*', schema: 'public', table: 'mensalistas' }, (payload) => {
        fetchMensalistasCount();
      })
      .subscribe();

    return () => {
      supabase.removeChannel(mensalistasChannel);
    };
  }, []);

  return (
    <AdminLayout>
      <Heading mb={{ base: 4, md: 8 }} fontSize={{ base: '2xl', md: '3xl' }}>Dashboard</Heading>
      <HStack
        spacing={{ base: 4, md: 8 }}
        mb={{ base: 6, md: 10 }}
        flexDir={{ base: 'column', md: 'row' }}
        align="stretch"
      >
        <Stat bg="gray.700" p={{ base: 4, md: 6 }} borderRadius="xl" boxShadow="md" minW={{ base: '100%', md: '220px' }}>
          <StatLabel fontSize={{ base: 'md', md: 'lg' }}>Atendimentos Hoje</StatLabel>
          <StatNumber fontSize={{ base: '2xl', md: '3xl' }}>
            {loading ? <Spinner size="sm" /> : atendimentosHoje}
          </StatNumber>
        </Stat>
        <Stat bg="gray.700" p={{ base: 4, md: 6 }} borderRadius="xl" boxShadow="md" minW={{ base: '100%', md: '220px' }}>
          <StatLabel fontSize={{ base: 'md', md: 'lg' }}>Clientes Ativos</StatLabel>
          <StatNumber fontSize={{ base: '2xl', md: '3xl' }}>11</StatNumber>
        </Stat>
        <Stat bg="gray.700" p={{ base: 4, md: 6 }} borderRadius="xl" boxShadow="md" minW={{ base: '100%', md: '220px' }}>
          <StatLabel fontSize={{ base: 'md', md: 'lg' }}>Mensalistas</StatLabel>
          <StatNumber fontSize={{ base: '2xl', md: '3xl' }}>{mensalistasCount}</StatNumber>
        </Stat>
      </HStack>
      <Box bg="gray.800" borderRadius="xl" p={{ base: 4, md: 8 }} boxShadow="md">
        <Heading size={{ base: 'sm', md: 'md' }} mb={4}>Bem-vindo ao Painel Administrativo!</Heading>
        <Box color="gray.300" fontSize={{ base: 'sm', md: 'md' }}>Aqui futuramente você poderá acompanhar os atendimentos, gerenciar clientes, configurar horários e muito mais.</Box>
      </Box>
    </AdminLayout>
  );
};

export default DashboardPage;
